export default __webpack_public_path__ + "static/media/padlock.b552cce3.svg";